module.exports = __webpack_public_path__ + "static/media/arrowRightGray.0423f29f.svg";